<template>
  <div>
    <el-card class="box-card">
      <template #header>
        <div class="card-header">
          <text-field
            v-model="curLvName"
            :base="base"
            name="current_level"
            :disabled="true"
          >
          </text-field>
        </div>
      </template>
      <el-card
        class="box-card"
        v-for="history in member_level_histories"
        :key="history.id"
      >
        <text-field
          v-model="history.level_name"
          :base="base"
          name="level"
          :disabled="true"
        >
        </text-field>
        <time-field
          v-model="history.end_time"
          :base="base"
          name="level_date"
          dataType="datetime"
          type="date"
          valueFormat="yyyy-MM-dd"
          disabled
        >
        </time-field>
      </el-card>
    </el-card>
  </div>
</template>

<script>
export default {
  name: 'member-level-detail',
  props: {
    base: {
      type: String,
      default: ''
    },
    member_level_histories: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    curLvName () {
      return this.member_level_histories.reduce((prev, cur) => {
        if (prev.level > cur.level) {
          return prev.level_name
        }
        return cur.level_name
      }, '')
    }
  }
}
</script>
